var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-list-group",class:_vm.variant ? `ui-list-group--${_vm.variant}` : ''},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }